// Scroll-linked horizontal marquee inside two tilted ribbons. The text in each
// ribbon drifts as the user scrolls past the section (opposite directions).
// Honors prefers-reduced-motion: in that case the inline transforms are not
// applied (CSS `!important` reset wins).
import { qs, qsa, on } from '../lib/dom.js';

const REDUCED = typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Pixels of horizontal travel per pixel of vertical scroll-progress through
// the section. Higher = faster drift. Tuned for the section's height.
const TRAVEL_PX = 320;

export function initTiltMarquee() {
  const section = qs('[data-component="tilt-marquee"]');
  if (!section) return;
  const tracks = qsa('[data-role="marquee-track"]', section);
  if (!tracks.length) return;
  if (REDUCED) return;

  let raf = 0;

  function update() {
    raf = 0;
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    // Progress from 0 (section bottom just entered viewport) to 1 (section top just left)
    const total = vh + rect.height;
    const raw = (vh - rect.top) / total;
    const progress = Math.max(0, Math.min(1, raw));
    // Map 0..1 → -1..1 so the ribbons drift symmetrically around the midpoint
    const t = progress * 2 - 1;
    tracks.forEach((track) => {
      const dir = parseFloat(track.dataset.direction || '1');
      const x = t * TRAVEL_PX * dir;
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    });
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  on(window, 'scroll', onScroll, { passive: true });
  on(window, 'resize', onScroll);
  update();
}
